import type BaseWidget from "widgets/BaseWidget";

export const EEWidgets: [string, () => Promise<typeof BaseWidget>][] = [
  [
    "MODULE_CONTAINER_WIDGET",
    async () =>
      import("./ModuleContainerWidget/widget").then(
        (m) => m.ModuleContainerWidget,
      ),
  ],
];
